<template>
  <div class="container" id="error-content">
    <v-layout column justify-center mt-4>
      <v-flex xl3 lg3>
        <img src="@/static/404.jpg" alt="page not found" />
      </v-flex>
      <v-flex>
        <br />

        <p class="display-22">
          לא מצאנו את הדף שביקשת,
          <br />
          אבל אולי תוכל/י
          <nuxt-link to="/" class="display-22">למצוא כאן עבודה.</nuxt-link>
        </p>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import gtm from '@/lib/gtm';

export default {
  name: 'pageErr',
  props: ['error'],


  mounted() {
    gtm({
      category: '404',
      action:
        this.error && this.error?.path ? this.error?.path : '',
      event: '404',
    });
  },
};
</script>

<style lang="scss" scoped>
#error-content {
  text-align: center;
}

#error-content img {
  max-width: 300px;
}
</style>